import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon OrdersAccountIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const OrdersAccountIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 24 24">
      <path
        d="M23 3.68456C23 2.75421 22.1972 2 21.2069 2H2.79311C1.8028 2 1 2.75421 1 3.68456V20.7454C1 21.6758 1.8028 22.43 2.79311 22.43H17.7046H21C22.1046 22.43 23 21.5346 23 20.43V14.9555M23 3.68456C23 3.68456 23 14.7039 23 14.9555M23 3.68456V14.9555"
        stroke="#503291"
      />
      <path d="M1 8H7.71212H8.95462" stroke="#503291" />
      <path
        d="M15 8.00957C17.6777 7.99582 18.468 7.99785 21.1458 8.00954H22.5183"
        stroke="#503291"
      />
      <path
        d="M9.00151 2V11.3088C9.00151 11.3088 8.95537 11.8833 9.37369 11.6374C9.792 11.3914 12.1234 10.1565 12.1234 10.1565C12.1234 10.1565 14.2161 11.4884 14.7137 11.838C15.2113 12.1875 15.1438 10.9599 15.1438 10.9599V2H9.00151Z"
        stroke="#503291"
      />
    </Icon>
  )
}
export default OrdersAccountIcon
